const state = {
  dictList: [],
  dictListMap: JSON.parse(localStorage.getItem('dictListMap')) || {},
};

const mutations = {
  SET_DICTLIST: (state, dictList) => {
    state.dictList = state.dictList.concat(dictList);
  },
  UPDATE_DICTLIST: (state, dictInfo) => {
    state.dictList[dictInfo.dictType] = dictInfo.dictList;
  },

  SET_DICTLIST_MAP: (state, dictList) => {
    state.dictListMap = Object.assign(state.dictListMap, dictList);
  },
  UPDATE_DICTLIST_MAP: (state, dictInfo) => {
    state.dictListMap[dictInfo.dictType] = dictInfo.dictList;
  },
};

const actions = {
  setDictList({ commit }, dictList) {
    commit('SET_DICTLIST', dictList);
  },

  updateDictList({ commit }, dictInfo) {
    state.dictList[dictInfo.dictType] = dictInfo.dictList;
    commit('UPDATE_DICTLIST', dictInfo);
  },

  setDictListMap({ commit }, dictList) {
    commit('SET_DICTLIST_MAP', dictList);
  },

  updateDictListMap({ commit }, dictInfo) {
    state.dictList[dictInfo.dictType] = dictInfo.dictList;
    commit('UPDATE_DICTLIST_MAP', dictInfo);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
